export enum ROLES {
  ADMIN = 'Admin',
  READER = 'Reader',
  CREATOR = 'Creator',
  SUPER_ADMIN = 'Super Admin',
  SUPER_ADMIN_VALUE = 'SuperAdmin',
}
export enum ACTIONS {
  UPDATE_ROLE = 'update_role',
  ADD_USER = 'add_user',
  DELETE_USER = 'delete_user',
  UPDATE_PROJECT = 'update_project',
  ADD_DEPARTMENT = 'add_department',
}
